import { IMAGE } from "../../image/image";
import { animated, useSpring } from "react-spring";
import { useEffect, useState } from "react";
import { FadeIn } from "../Animation/FadeIn";

type LUANCH_APP = {
  isVisible: boolean;
};

export const LuanchApp = () => {
  return (
    <FadeIn>
      <div className="container">
        <div className="section">
          <div className="luanch-app-container">
            <div className="m-auto-tb">
              <div className="out-fit-title-text">Homies</div>
              <div className="mt-40">
                <div className="out-fit-detail-text">
                  are born from positivity and creativity of the NFT space to{" "}
                  help frens ride the space happily via the community tools.
                </div>
              </div>
              <div className="luanch-app-button-container">
                <div className="mt-40">
                  <button className="button-large">Launch App</button>{" "}
                </div>
              </div>
            </div>
            <div className="width-rocket-img">
              <img
                src={IMAGE.HOMEPAGE.ROCKET}
                className="width-rocket-img"
                alt="homies rocket"
              ></img>
            </div>{" "}
          </div>
        </div>
      </div>{" "}
    </FadeIn>
  );
};
